import { render } from "./EditProjectAllocation.vue?vue&type=template&id=c40297d8&scoped=true"
import script from "./EditProjectAllocation.vue?vue&type=script&lang=js"
export * from "./EditProjectAllocation.vue?vue&type=script&lang=js"

import "./EditProjectAllocation.vue?vue&type=style&index=0&id=c40297d8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c40297d8"]])

export default __exports__